const projects = [{
  path: '/projects',
  component: () => import('@/views/Projects/Index'),
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    name: 'projects',
    component: () => import('@/views/Projects/List.vue')
  }, {
    path: 'actions/:project_id?',
    name: 'project_actions',
    component: () => import('@/views/Projects/Actions.vue')
    /* children: [{
      path: 'activities',
      name: 'activities',
      component: () => import('@/views/Activity/Activity.vue')
    }, {
      path: 'members',
      name: 'members',
      component: () => import('@/views/Member/Member.vue')
    }] */
  }]
}]

export default projects
